import { useTranslation } from "react-i18next";

export const FAQLink = () => {
  const { t } = useTranslation();

  return (
    <a
      className="text-foreground-primary underline"
      href={t("portal:authenticator.app.setup.step1.faqUrl")}
      target="_blank"
      rel="noreferrer"
    >
      {t("portal:authenticator.app.setup.step1.faqOn2faApps")}
    </a>
  );
};
